"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Panel_1 = tslib_1.__importDefault(require("./Panel"));
/**
 * @deprecated reconsider the use-case of this class
 */
class SimplePanel extends Panel_1.default {
    add(domElement) {
        this.clearHTMLChildren();
        super.add(domElement);
    }
}
exports.default = SimplePanel;
//# sourceMappingURL=SimplePanel.js.map